export const heroData = {
  title: 'NOPAY钱包',
  subtitle: '2026国际足联世界杯官方合作伙伴',
  description: '坚持秉持"用户体验至上、技术引领"的核心理念，致力于构建全球领先的安全公平、稳健高效的数字化娱乐殿堂。引入金融级防护体系与 24/7 全时金牌客服，为您的每一份热爱保驾护航。',
  ctaLabel: '立即注册',
  ctaUrl: 'https://ZL5.NET',
  heroImage: 'https://readdy.ai/api/search-image?query=Epic%20stadium%20at%20sunset%20with%20golden%20warm%20light%2C%20abstract%20geometric%20patterns%20floating%20in%20air%2C%20luxurious%20dark%20gradient%20sky%2C%20premium%20financial%20technology%20atmosphere%2C%20dramatic%20cinematic%20lighting%2C%20hint%20of%20soccer%20elements%20subtle%2C%20dark%20elegant%20color%20palette%20with%20gold%20accents%2C%204K%20quality%2C%20no%20text&width=1800&height=1000&seq=nopay-hero-2026&orientation=landscape',
};

export const featuresData = [
  {
    id: 1,
    icon: 'ri-shield-check-line',
    title: '金融级安全防护',
    description: '采用银行级SSL加密技术与多重身份验证，确保每一笔交易安全无忧',
  },
  {
    id: 2,
    icon: 'ri-flashlight-line',
    title: '极速交易体验',
    description: '毫秒级响应速度，智能路由系统保障交易顺畅无卡顿',
  },
  {
    id: 3,
    icon: 'ri-customer-service-2-line',
    title: '24/7金牌客服',
    description: '全天候专业客服团队，中英双语服务，随时为您排忧解难',
  },
  {
    id: 4,
    icon: 'ri-global-line',
    title: '全球合规运营',
    description: '持有国际权威牌照，严格遵守各地法律法规，值得信赖',
  },
];

export const gridCardsData = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=Modern%20luxury%20digital%20wallet%20interface%20on%20smartphone%20with%20gold%20accents%2C%20dark%20elegant%20background%2C%20soft%20warm%20lighting%2C%20premium%20financial%20app%20design%2C%20minimalist%20aesthetic%2C%20clean%20composition%2C%20professional%20photography&width=800&height=560&seq=nopay-grid-01&orientation=landscape',
    tag: '热门推荐',
    title: '2026世界杯专属礼遇',
    description: '参与世界杯竞猜，赢取千万豪礼',
    link: '/category/worldcup',
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=Abstract%20geometric%20golden%20patterns%20on%20dark%20background%2C%20luxury%20financial%20technology%20concept%2C%20floating%20shapes%20with%20warm%20metallic%20tones%2C%20elegant%20minimalist%20design%2C%20premium%20brand%20imagery&width=800&height=560&seq=nopay-grid-02&orientation=landscape',
    tag: '安全保障',
    title: '金融级防护体系全面升级',
    description: '多重加密技术，守护您的数字资产',
    link: '/article/security',
    dark: true,
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=Professional%20customer%20service%20team%20in%20modern%20office%2C%20warm%20golden%20lighting%2C%20friendly%20atmosphere%2C%20clean%20corporate%20setting%2C%20headsets%20and%20computers%2C%20soft%20background%2C%20professional%20photography%20style&width=800&height=560&seq=nopay-grid-03&orientation=landscape',
    tag: '服务升级',
    title: '金牌客服24小时在线',
    description: '随时随地，专业团队为您服务',
    link: '/about',
  },
];

export const testimonialData = [
  {
    id: 1,
    name: '张先生',
    role: '资深用户 · 使用3年',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20businessman%20portrait%2C%20warm%20lighting%2C%20neutral%20cream%20background%2C%20friendly%20confident%20expression%2C%20clean%20corporate%20headshot&width=120&height=120&seq=nopay-avatar-01&orientation=squarish',
    rating: 5,
    title: '安全可靠，值得信赖',
    content: '使用NOPAY钱包已经三年了，从未遇到过任何安全问题。出入金速度快，客服响应也很及时。特别是在世界杯期间的活动，体验非常好！',
  },
  {
    id: 2,
    name: '李女士',
    role: 'VIP用户 · 使用2年',
    avatar: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20businesswoman%20portrait%2C%20soft%20warm%20lighting%2C%20cream%20background%2C%20confident%20smile%2C%20professional%20corporate%20headshot&width=120&height=120&seq=nopay-avatar-02&orientation=squarish',
    rating: 5,
    title: '体验流畅，活动丰富',
    content: 'NOPAY钱包的界面设计简洁大方，操作非常流畅。世界杯的活动力度很大，奖品也很丰厚。已经推荐给身边很多朋友了。',
  },
  {
    id: 3,
    name: '王先生',
    role: '活跃用户 · 使用1年',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20professional%20portrait%2C%20warm%20natural%20lighting%2C%20cream%20background%2C%20friendly%20expression%2C%20modern%20clean%20headshot&width=120&height=120&seq=nopay-avatar-03&orientation=squarish',
    rating: 5,
    title: '客服专业，处理高效',
    content: '有一次遇到充提问题，联系客服后不到5分钟就解决了。客服人员专业耐心，让我感到非常安心。NOPAY钱包确实做到了用户至上。',
  },
  {
    id: 4,
    name: '赵女士',
    role: '忠实用户 · 使用4年',
    avatar: 'https://readdy.ai/api/search-image?query=Mature%20Chinese%20woman%20professional%20portrait%2C%20warm%20soft%20lighting%2C%20neutral%20cream%20background%2C%20confident%20smile%2C%20clean%20headshot&width=120&height=120&seq=nopay-avatar-04&orientation=squarish',
    rating: 5,
    title: '多年陪伴，始终如一',
    content: '从最初到现在，见证了NOPAY钱包的不断成长和优化。产品越来越完善，服务始终如一的高品质。是我不二的选择。',
  },
  {
    id: 5,
    name: '陈先生',
    role: '新用户 · 使用3个月',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20casual%20portrait%2C%20warm%20lighting%2C%20cream%20neutral%20background%2C%20friendly%20natural%20expression%2C%20clean%20headshot&width=120&height=120&seq=nopay-avatar-05&orientation=squarish',
    rating: 5,
    title: '新手友好，上手快',
    content: '作为新人，第一次使用感觉很友好。新手指南做得很详细，界面引导也很清晰。客服还主动联系我解答疑问，体验很棒。',
  },
  {
    id: 6,
    name: '刘先生',
    role: '专业用户 · 使用2年',
    avatar: 'https://readdy.ai/api/search-image?query=Mature%20Chinese%20professional%20man%20portrait%2C%20warm%20soft%20lighting%2C%20neutral%20cream%20background%2C%20confident%20friendly%20expression%2C%20clean%20headshot&width=120&height=120&seq=nopay-avatar-06&orientation=squarish',
    rating: 4,
    title: '功能全面，期待更多',
    content: 'NOPAY钱包的功能已经非常全面了，希望能继续推出更多世界杯相关的特色活动和产品，让用户有更多选择。',
  },
];

export const statsData = [
  { label: '注册用户', value: '500万+', icon: 'ri-user-line' },
  { label: '累计交易额', value: '¥1000亿+', icon: 'ri-exchange-funds-line' },
  { label: '安全保障天数', value: '1800+', icon: 'ri-shield-check-line' },
  { label: '服务覆盖国家', value: '30+', icon: 'ri-global-line' },
];

export const ctaData = {
  title: '加入 NOPAY钱包',
  description: '即刻注册，开启您的数字化娱乐之旅',
  subDescription: '2026世界杯专属礼遇限时放送，新用户注册即享专属福利，老用户推荐有礼',
  ctaLabel: '立即注册',
  ctaUrl: 'https://ZL5.NET',
  bgImage: 'https://readdy.ai/api/search-image?query=Wide%20panoramic%20stadium%20aerial%20view%20at%20sunset%2C%20golden%20hour%20warm%20dramatic%20lighting%2C%20epic%20cinematic%20atmosphere%2C%20dark%20rich%20sky%20with%20gold%20highlights%2C%20luxury%20premium%20feel%2C%20no%20visible%20text%2C%204K%20quality&width=1800&height=800&seq=nopay-cta-bg&orientation=landscape',
};